import { version } from '../../package.json';

const {
  VITE_API_SERVICE_URI,
  VITE_MAPBOX_USER,
  VITE_MAPBOX_STYLE,
  VITE_MAPBOX_PUBLIC_TOKEN,
  VITE_ENVIRONMENT,
  VITE_SHOP_COMPONENT_LOADER_URI,
  VITE_NUVO_LICENSE_KEY,
  VITE_RETRACED_ENV,
  VITE_IS_COOKIE_ENABLED,
  VITE_RETRACED_ADMIN_COMPANY_ID,
  VITE_CERTIFIED_MATERIALS_SERVICE_URI,
  VITE_IS_STYLE_STRUCTURE_ENABLED,
} = import.meta.env;

export default {
  api: {
    host: VITE_API_SERVICE_URI,
  },
  map: {
    mapboxUser: VITE_MAPBOX_USER,
    mapboxStyle: VITE_MAPBOX_STYLE,
    mapboxAccessToken: VITE_MAPBOX_PUBLIC_TOKEN,
    center: [20, 0],
  },
  environment: VITE_ENVIRONMENT,
  shopComponentLoaderUri: VITE_SHOP_COMPONENT_LOADER_URI,
  nuvoLicenseKey: VITE_NUVO_LICENSE_KEY,
  retracedAdminCompanyId: VITE_RETRACED_ADMIN_COMPANY_ID,
  isCookieEnabled: JSON.parse(VITE_IS_COOKIE_ENABLED ?? null),
  isStyleStructureEnabled: VITE_IS_STYLE_STRUCTURE_ENABLED === 'true',
  certifiedMaterialsServiceUri: VITE_CERTIFIED_MATERIALS_SERVICE_URI,
  datadogRum: {
    applicationId: '057c75e5-bb0f-48a2-a228-c4bca2c782d9',
    clientToken: 'pub412d965c8ad6bab81dd2bcd7eea26b83',
    site: 'datadoghq.eu',
    service: 'dashboard-web',
    env: VITE_RETRACED_ENV,
    version: `v${version}`,
    sampleRate: 100,
    premiumSampleRate: 100,
    trackInteractions: true,
    // By default allow visualization of all content in Datadog replay. We hide specific fields with
    // https://docs.datadoghq.com/real_user_monitoring/session_replay/privacy_options/
    // field specific data-dd-privacy="mask"
    defaultPrivacyLevel: 'allow',
  },
};
